import axios from "axios";
import { enqueue } from "./offlineQueue";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("asc_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Endpoints that MUST NEVER be queued offline (auth, payments, scans, impersonation, admin).
const NEVER_QUEUE = [
  /\/auth\//,
  /\/admin\//,
  /\/public\//,         // public ticketing/payments
  /\/uploads/,
  /\/ticketing\/scan/,
];

function shouldQueue(method, url) {
  const m = (method || "GET").toUpperCase();
  if (m === "GET") return false;
  if (NEVER_QUEUE.some((rx) => rx.test(url || ""))) return false;
  return true;
}

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    if (err.response?.status === 401) {
      const path = window.location.pathname;
      if (path !== "/" && path !== "/login" && path !== "/register") {
        localStorage.removeItem("asc_token");
        window.location.href = "/login";
      }
      return Promise.reject(err);
    }

    // Network failure (no response) → queue mutating requests for later sync
    const cfg = err.config || {};
    const isNetworkErr = !err.response && (err.message === "Network Error" || err.code === "ERR_NETWORK" || !navigator.onLine);
    if (isNetworkErr && shouldQueue(cfg.method, cfg.url)) {
      try {
        await enqueue({
          method: (cfg.method || "POST").toUpperCase(),
          url: cfg.url,
          data: cfg.data ? (typeof cfg.data === "string" ? JSON.parse(cfg.data) : cfg.data) : null,
          headers: cfg.headers && cfg.headers.Authorization ? { Authorization: cfg.headers.Authorization } : null,
        });
        // Return a synthetic OK response so the UI proceeds optimistically
        return {
          data: { __queued: true },
          status: 202,
          statusText: "Queued offline",
          headers: {},
          config: cfg,
        };
      } catch (e) {
        // If queueing itself fails, propagate the original error
      }
    }
    return Promise.reject(err);
  },
);

export default api;
